module.exports = __webpack_public_path__ + "img/theroom_plant_thumb.ef4c316c.jpg";